/// <reference path="../../setup/_references.ts" />
module onvio.practice.widgets {
    'use strict';

    export class BmPracticeWidgetMyAssignments implements IBmPracticeWidgetService {

        /** Flag if the widget is busy */
        public isBusy: boolean = false;

        /** Templates for the widget */
        public bodyTemplate: string = 'practice-widgets/my-assignments/my-assignments.html';

        /** Show in graph mode */
        public graph: boolean = false;

        public size: WidgetSize = 'large';

        static $inject = [
            '$q'
        ];
        constructor(
            private $q: ng.IQService
        ) {
                // Nothing required here
        }

        // If we don't use this function the code will break, but it isn't needed for this
        // widget so just return nothing
        public loadData(args: IBmPracticeWidgetLoadDataArgs): ng.IPromise<any> {
            return this.$q.when(undefined);
        }

    }

    angular.module('bm.practice.widgets.myAssignments', [])
        .service('bm-practice-widget-my-assignments', BmPracticeWidgetMyAssignments);
}
